/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LoginTokenBeforeTimeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('LOGIN_TOKEN_BEFORE_TIME')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ codecArray(parsers.duration)),
    ],
]);
export class LoginTokenBeforeTimeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LoginTokenBeforeTimeSettingParser.decode(input).map(res => new LoginTokenBeforeTimeSetting(res));
    }
    static unsafeDecode(input) {
        return LoginTokenBeforeTimeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LoginTokenBeforeTimeSettingParser.encode(data);
    }
    static schema() {
        return LoginTokenBeforeTimeSettingParser.schema();
    }
}
